export default {
  default: () => import("/usr/src/app/layouts/default.vue").then(m => m.default || m),
  empty: () => import("/usr/src/app/layouts/empty.vue").then(m => m.default || m),
  error: () => import("/usr/src/app/layouts/error.vue").then(m => m.default || m)
}